export const isProduction = process.env.NODE_ENV === 'production';



export const NetworkContextName = 'NETWORK';
export const connectorLocalStorageKey = 'connectorId';
export enum ChainId {
  ETH_MAINNET = 1,
  ETH_ROPSTEN = 3,
  ETH_RINKEBY = 4,
  ETH_GOERLI = 5,
  ETH_KOVAN = 42,

  BSC_MAINNET = 56,
  BSC_TESTNET = 97,
};
export enum ConnectorNames {
  Injected = 'injected',
  WalletConnect = 'walletconnect',
}

export const nullAddress = '0x0000000000000000000000000000000000000000';
